import { useEffect, useState, type MouseEvent, type ReactNode } from "react";

/** A tiny path router: CloudFront answers every path with index.html, the app picks the page. */
const listeners = new Set<() => void>();

export function navigate(to: string) {
  window.history.pushState(null, "", to);
  listeners.forEach((l) => l());
}

export function useLocation(): { path: string; query: URLSearchParams } {
  const [, force] = useState(0);
  useEffect(() => {
    const update = () => force((n) => n + 1);
    listeners.add(update);
    window.addEventListener("popstate", update);
    return () => {
      listeners.delete(update);
      window.removeEventListener("popstate", update);
    };
  }, []);
  return { path: window.location.pathname, query: new URLSearchParams(window.location.search) };
}

export function Link({ to, children, className, ...rest }: { to: string; children: ReactNode; className?: string; "aria-current"?: "page" }) {
  function onClick(e: MouseEvent<HTMLAnchorElement>) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  }
  return (
    <a href={to} onClick={onClick} className={className} {...rest}>
      {children}
    </a>
  );
}
